import MonthlyReportContent from "./MonthlyReportContent.vue";
export default MonthlyReportContent;
